import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="max-w-lg mx-auto text-center py-16">
      <div className="w-16 h-16 rounded-full bg-slate-100 grid place-items-center mx-auto">
        <XCircle size={32} className="text-slate-500" />
      </div>
      <h1 className="font-heading text-3xl font-extrabold mt-6">Payment cancelled</h1>
      <p className="text-slate-600 mt-2">No charges were made. You can try again anytime.</p>
      <Button onClick={() => navigate("/my-tasks")} className="mt-6 rounded-full">Back to my tasks</Button>
    </div>
  );
}
